var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nav-top row-center"},[_c('h1',[_c('a',{attrs:{"href":"https://www.ufv.es/otros-servicios/familias-ufv"}},[_c('img',{staticClass:"logo-padres",attrs:{"src":"/img/logo-padres-head.png","width":"200px","alt":"logo-padres"}})])]),_c('span')])])
}]

export { render, staticRenderFns }